module.exports = __webpack_public_path__ + "static/media/grouplogo.d0b7a340.png";